import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'

export class PersonalSlide {
  constructor() {
    this.personalSliders = document.querySelectorAll(
      '.p-personal-slider'
    )
    if (!this.personalSliders.length) {
      return
    }

    this._init()
  }

  _init() {
    this.personalSliders.forEach(personalSlider => {
      const targetSlider = personalSlider.querySelector('.swiper')
      const targetPagination = personalSlider.querySelector(
        '.p-personal-slider_pagination'
      )
      const options = {
        modules: [Navigation, Pagination, Autoplay],
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: targetPagination,
        },
      }

      new Swiper(targetSlider, options)
    })
  }
}

export class CardSlide {
  constructor(element) {
    this.cardSlide = element
    if (!this.cardSlide) {
      return
    }

    this.cardSlideContainer = this.cardSlide.querySelector(
      '.js-card-slide_container'
    )
    this.recommendProgress = this.cardSlide.querySelector(
      '.c-slide-progress .swiper-pagination'
    )
    this.prev = this.cardSlide.querySelector('.js-slide-btn_prev')
    this.next = this.cardSlide.querySelector('.js-slide-btn_next')

    this._init()
  }

  _init() {
    const options = {
      modules: [Navigation, Pagination, Autoplay],
      loop: false,
      autoplay: false,
      slidesPerView: 1.4,
      // centeredSlides: true,//1枚目のスライド中央配置
      navigation: {
        prevEl: this.prev,
        nextEl: this.next,
      },
      pagination: {
        el: this.recommendProgress,
        type: 'progressbar',
      },
      breakpoints: {
        // 568px以上の場合
        568: {
          slidesPerView: 2.2,
        },
        // 768px以上の場合
        768: {
          slidesPerView: 2.9,
        },
      },
    }
    new Swiper(this.cardSlideContainer, options)
  }
}

export class MvSlide {
  constructor(element) {
    this.mvSlide = element
    if (!this.mvSlide) {
      return
    }

    this.mvSlideContainer = this.mvSlide.querySelector(
      '.js-mv-slide_container'
    )
    this._init()
  }

  _init() {
    const options = {
      modules: [Navigation, Pagination, Autoplay],
      loop: true,
      autoplay: true,
      slidesPerView: 1,
    }
    new Swiper(this.mvSlideContainer, options)
  }
}
